module.exports = __webpack_public_path__ + "static/media/logo.e509716b.svg";